import { Grid, GridItem, Text } from "@chakra-ui/react";

const Luminaires = ({luminaires}) => {
    if (!luminaires || luminaires.length === 0) return null;

    console.log('Luminaires', luminaires)
    return (
        luminaires.flatMap((item, index) => {
            const baseFixtureQty = Number(
                item.recomendedFixtureQty ||
                item.globalRecomendedFixtureQty ||
                item.qty ||
                item.globalQty ||
                1
            );

            const rows = []

            rows.push(
                <Grid templateColumns='repeat(7, 1fr)' key={`main-${index}`} px={4} border='1px solid #A9A9A9' borderRadius='6px'
                      minH='64px' alignItems='center' mb={5}>
                    <GridItem colSpan={3}>
                        {item?.lampRecomendedAirtable?.length > 0 ? JSON.parse(item.lampRecomendedAirtable)['FE Product Description'] : item.fixtureRecomendedAirtableArray[0]['fields']['FE Product Description']}
                    </GridItem>
                    <GridItem colSpan={1} textAlign='center'>
                        {item?.lampRecomendedAirtable?.length > 0 ? JSON.parse(item.lampRecomendedAirtable)['Order Code'] : item.fixtureRecomendedAirtableArray[0]['fields']['Order Code']}
                    </GridItem>
                    <GridItem colSpan={1} textAlign='center'>
                        {
                            item.recomendedFixtureQty ? item.recomendedFixtureQty : item.globalRecomendedFixtureQty ? item.globalRecomendedFixtureQty : item.qty
                            ? item.qty * item.lampPerFixture
                            : item.globalQty * item.lampPerFixture
                        }
                    </GridItem>
                    <GridItem colSpan={1} textAlign='center'>
                        {
                            item?.lampRecomendedAirtable?.length > 0 && JSON.parse(item?.lampRecomendedAirtable)['SU PPU ($) Custom'] ? '$' + JSON.parse(item.lampRecomendedAirtable)['SU PPU ($) Custom'] :
                                item?.fixtureRecomendedAirtableArray?.length > 0 && item.fixtureRecomendedAirtableArray[0]?.fields?.['SU PPU ($) Custom'] ? '$' + item.fixtureRecomendedAirtableArray[0].fields['SU PPU ($) Custom'] :
                                    (Number(item.recomendedFixtureQty) || Number(item.recomendedLampQty) || 1) >= 100 &&
                                    (Number(item.recomendedFixtureQty) || Number(item.recomendedLampQty) || 1) < 200 ?
                                        (item?.lampRecomendedAirtable?.length > 0 ? '$' + (JSON.parse(item.lampRecomendedAirtable)['Volume Tier 1 PPU ($)'] ? String(JSON.parse(item.lampRecomendedAirtable)['Volume Tier 1 PPU ($)']).replace(/[^\d.]/g, '') : '0') : '$' + (item.fixtureRecomendedAirtableArray[0]?.fields?.['Volume Tier 1 PPU ($)'] ? Number(item.fixtureRecomendedAirtableArray[0].fields['Volume Tier 1 PPU ($)']).toFixed(2) : '0'))
                                        : (Number(item.recomendedFixtureQty) || Number(item.recomendedLampQty) || 1) >= 200 ?
                                            (item?.lampRecomendedAirtable?.length > 0 ? '$' + (JSON.parse(item.lampRecomendedAirtable)['Volume Tier 2 PPU ($)'] ? Number(JSON.parse(item.lampRecomendedAirtable)['Volume Tier 2 PPU ($)']).toFixed(2) : '0') : '$' + (item.fixtureRecomendedAirtableArray[0]?.fields?.['Volume Tier 2 PPU ($)'] ? Number(item.fixtureRecomendedAirtableArray[0].fields['Volume Tier 2 PPU ($)']).toFixed(2) : '0'))
                                            : item?.lampRecomendedAirtable?.length > 0 ? '$' + Number(JSON.parse(item.lampRecomendedAirtable)['Price Per Unit ($)'] || '0').toFixed(2) : '$' + String(item.fixtureRecomendedAirtableArray[0]?.fields?.['Price Per Unit ($)'] || '0')
                        }
                    </GridItem>
                    <GridItem colSpan={1} textAlign='center'>
                        {
                            (() => {
                                const lampQty =
                                    item?.recomendedLampQty
                                        ? Number(item.recomendedLampQty)
                                        : item?.lampPerFixture
                                            ? item.lampPerFixture
                                            : 1;

                                const fixtureQty =
                                    item?.recomendedFixtureQty
                                        ? Number(item.recomendedFixtureQty)
                                        : item?.qty
                                            ? Number(item.qty)
                                            : 1;

                                const isFixture = item?.fixtureRecomendedAirtableArray?.length > 0;

                                const multiplier = isFixture ? fixtureQty : lampQty * fixtureQty;

                                const lamp = item?.lampRecomendedAirtable?.length > 0
                                    ? JSON.parse(item.lampRecomendedAirtable)
                                    : null;

                                const fixture = item?.fixtureRecomendedAirtableArray?.[0]?.fields;

                                const getPrice = () => {
                                    if (lamp?.['SU PPU ($) Custom']) return lamp['SU PPU ($) Custom'];
                                    if (fixture?.['SU PPU ($) Custom']) return fixture['SU PPU ($) Custom'];

                                    const qty = isFixture ? fixtureQty : lampQty;

                                    if (qty >= 200) {
                                        return lamp?.['Volume Tier 2 PPU ($)'] ||
                                            fixture?.['Volume Tier 2 PPU ($)'] || 1;
                                    }

                                    if (qty >= 100) {
                                        return lamp?.['Volume Tier 1 PPU ($)'] ||
                                            fixture?.['Volume Tier 1 PPU ($)'] || 1;
                                    }

                                    return lamp?.['Price Per Unit ($)'] ||
                                        fixture?.['Price Per Unit ($)'] || 0;
                                };

                                const unitPrice = Number(String(getPrice()).replace(/[^\d.]/g, ''));

                                return '$' + (unitPrice * multiplier).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            })()
                        }
                    </GridItem>
                </Grid>
            );
            const getSubItemRow = (jsonStr, airtableArray, subItemQtyInput, uniqueKey) => {
                const hasJson = jsonStr && jsonStr.length > 0;
                const hasArray = airtableArray && airtableArray.length > 0;

                if (!hasJson && !hasArray) return null;

                let fields = null;
                if (hasJson) {
                    try { fields = JSON.parse(jsonStr); } catch (e) { console.error(e); }
                } else if (hasArray) {
                    fields = airtableArray[0]?.fields || airtableArray[0];
                }

                if (!fields) return null;

                const subQty = Number(subItemQtyInput) || 1;
                const totalQty = subQty * baseFixtureQty;

                const description = fields['FE Product Description'] || '';
                const orderCode = fields['Order Code'] || '';

                const getPrice = () => {
                    if (fields['SU PPU ($) Custom']) return fields['SU PPU ($) Custom'];
                    if (totalQty >= 200) return fields['Volume Tier 2 PPU ($)'] || 1;
                    if (totalQty >= 100) return fields['Volume Tier 1 PPU ($)'] || 1;
                    return fields['Price Per Unit ($)'] || 0;
                };

                const unitPrice = Number(String(getPrice()).replace(/[^\d.]/g, '')) || 0;
                const totalPrice = unitPrice * totalQty;

                return (
                    <Grid templateColumns='repeat(7, 1fr)' key={uniqueKey} px={4} border='1px solid #A9A9A9' borderRadius='6px'
                          minH='64px' alignItems='center' mb={5}>
                        <GridItem colSpan={3}>
                            {description}
                        </GridItem>
                        <GridItem colSpan={1} textAlign='center'>
                            {orderCode}
                        </GridItem>
                        <GridItem colSpan={1} textAlign='center'>
                            {totalQty}
                        </GridItem>
                        <GridItem colSpan={1} textAlign='center'>
                            {'$' + unitPrice.toFixed(2)}
                        </GridItem>
                        <GridItem colSpan={1} textAlign='center'>
                            {'$' + totalPrice.toLocaleString('en-US', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            })}
                        </GridItem>
                    </Grid>
                );
            };

            const controlRow = getSubItemRow(
                item?.controlRecomendedAirtable,
                item?.controlRecomendedAirtableArray,
                item?.controlQty || item?.controlRecomendedQty,
                `control-${index}`
            );
            if (controlRow) rows.push(controlRow);

            const powerRow = getSubItemRow(
                item?.powerSupplyRecomendedAirtable,
                item?.powerSupplyRecomendedAirtableArray,
                item?.powerSupplyQty || item?.powerSupplyRecomendedQty || item?.powerQty,
                `power-${index}`
            );
            if (powerRow) rows.push(powerRow);

            const accessoryRow = getSubItemRow(
                item?.accessoryRecomendedAirtable,
                item?.accessoryRecomendedAirtableArray,
                item?.accessoryQty || item?.accessoryRecomendedQty,
                `accessory-${index}`
            );
            if (accessoryRow) rows.push(accessoryRow);

            return rows;
        })
    )
}

export default Luminaires;